/**
 * Registro de erros do front (padrão P-S5, src/docs/padroes-front.md; onda O3).
 *
 * Único lugar que escreve no console. Nunca registra dados: só o contexto (texto fixo do código) e o código HTTP
 * ou a mensagem técnica do erro. O objeto de erro do axios NÃO é registrado — ele carrega a requisição inteira
 * (corpo com dados do paciente, cabeçalhos). Em testes não escreve nada.
 *
 * @param {string} contexto texto fixo, ex.: 'IndexTabelasPrecos' ou 'Erro ao excluir'
 * @param {unknown} [erro] erro capturado (opcional)
 */
export function registrarErro(contexto, erro) {
  if (process.env.NODE_ENV === 'test') return
  // eslint-disable-next-line no-console
  console.warn(`[TeraBlues] ${String(contexto || '').replace(/[:\s]+$/, '')}${detalheSeguro(erro) ? ` — ${detalheSeguro(erro)}` : ''}`)
}

/** Só o que não contém dado: código HTTP, código de negócio do back ou o tipo/mensagem de erro de execução. */
export function detalheSeguro(erro) {
  if (erro == null) return ''
  const status = erro?.response?.status
  if (status) return `HTTP ${status}${erro.response.data?.codigo ? ` ${erro.response.data.codigo}` : ''}`
  if (erro?.request && !erro?.response) return 'sem resposta do servidor'
  if (erro instanceof Error) return erro.name === 'Error' ? erro.message.slice(0, 120) : erro.name
  return ''
}
